import type { FC } from "react";

import type { StoreExtendedParams, StoreIcons } from "@locators/components/StoreLocator";
import {
  StoreLocatorCard,
  StoreLocatorContext,
  StoreLocatorMap,
  StoreLocatorProviderWrapper,
  useStoreLocator,
  useStoreTrackingEvent,
} from "@locators/components/StoreLocator";

import type { FlotiqStore } from "@jti/fe-common";

import styles from "../../StoreDetails.module.scss";

type StoreDetailsMapProps = {
  store: FlotiqStore;
  storeIcons?: StoreIcons[];
  componentLevelLanguage?: string;
} & StoreExtendedParams;

export const StoreDetailsMap: FC<StoreDetailsMapProps> = (props) => {
  const { store } = props;

  const publishStoreTrackingEvent = useStoreTrackingEvent();

  const storeLocatorData = useStoreLocator({
    defaultLat: String(store.Location.lat || 0),
    defaultLng: String(store.Location.lon || 0),
    defaultZoom: 15,
    activeStore: store,
    ...props,
  });

  return (
    <StoreLocatorProviderWrapper componentLevelLanguage={props.componentLevelLanguage}>
      <StoreLocatorContext.Provider value={storeLocatorData}>
        <StoreLocatorCard
          className={styles.storeDetailsCard}
          isActive={false}
          store={store}
          isListView={false}
          onGetDirectionClick={() => {
            publishStoreTrackingEvent(store.id, store.StoreName, store.storetype ?? "");
          }}
        />
        <div className={styles.mapContainer}>
          <StoreLocatorMap className={styles.storeDetailsMapWrapper} />
        </div>
      </StoreLocatorContext.Provider>
    </StoreLocatorProviderWrapper>
  );
};
